'use client';

import { Loader2 } from 'lucide-react';
import { forwardRef, memo } from 'react';
import { ReportWithDetails } from '../../../../types/shared';
import { useTrafficMap } from './useTrafficMap';

export interface TrafficMapHandle {
  panTo: (coords: number[]) => void;
}

type Props = {
  reports: ReportWithDetails[];
  onMapClick: (coords: number[]) => void;
  isSelectMode: boolean;
  shouldLoad?: boolean;
};

export const TrafficMap = memo(
  forwardRef<TrafficMapHandle, Props>((props, ref) => {
    const { mapContainerRef, isMapsLoaded } = useTrafficMap(props, ref);

    return (
      <div className="w-full h-full relative rounded-lg bg-slate-800 overflow-hidden">
        {!isMapsLoaded && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-slate-800/80">
            <Loader2 className="animate-spin text-sky-400" size={40} />
            <p className="mt-4 text-white">Загрузка карты...</p>
          </div>
        )}

        <div ref={mapContainerRef} className="w-full h-full" />
      </div>
    );
  }),
);

TrafficMap.displayName = 'TrafficMap';
